import React, { useContext, useState, useEffect } from 'react'
import FlexView from 'react-flexview/lib'
import { Grid, TextField, useMediaQuery, Divider } from '@material-ui/core'
import { useForm } from 'react-hook-form'
import { SessionContextStore } from '../../context/SessionContext'
import './ManageProfile.scss'
import { ApproveRefferalRequest } from './ApproveReferralRequest'

var classNames = require('classnames')

export const RefferalRequests = () => {
  const sessionContext = React.useContext(SessionContextStore)
  const [openRefferedRequests, setOpenRefferedRequests] = useState()

  const closeReffedRequest = (declination) => {
    var temp = openRefferedRequests.filter(
      (x) => x.property != declination.reason
    )
    if (temp.length == 0) {
      window.location.reload()
    }
    setOpenRefferedRequests(temp)
  }

  useEffect(() => {
    if (sessionContext.user.declinations != undefined) {
      sessionContext.user.declinations.forEach(
        (e) => (e.declined = e.type === 'Decline')
      )
    }
    setOpenRefferedRequests(sessionContext.user.declinations)
  }, [sessionContext.user.declinations])

  return (
    <FlexView column>
      <Grid spacing={3}>
        {sessionContext.user.declinations == undefined ||
        sessionContext.user.declinations.length == 0 ? (
          <h4>No open refferal requests</h4>
        ) : (
          sessionContext.user.declinations.map((declination) => (
            <>
              <ApproveRefferalRequest
                closeReffedRequest={closeReffedRequest}
                allowed={declination.override_type == 'Allow'}
                declined={declination.override_type == 'Decline'}
                declinationDate={declination.declination_date}
                reason={declination.property}
                comment={declination.payload}
                payload={declination.payload}
              />
              <Divider />
            </>
          ))
        )}
      </Grid>
    </FlexView>
  )
}
